module.exports = __webpack_public_path__ + "img/icon-banner-dexid.3dfd26da.svg";